var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 12H1.333a1.334 1.334 0 000 2.667h13.334a1.333 1.333 0 000-2.667zM14.667 1.333H1.333a1.333 1.333 0 000 2.667h13.334a1.333 1.333 0 000-2.667zM14.667 6.667H1.333a1.333 1.333 0 100 2.666h13.334a1.333 1.333 0 000-2.666z",
    fill: "#fff"
  })));
}
export default SvgHamburger;